import { Controller } from "@hotwired/stimulus";

// GR-1981 — deep-linked entries (…/event-log#event-log-entry-42) live inside the
// v2 form layout's own scroll container, not the window, so the browser's native
// anchor scroll never reaches them (only the :target highlight fires). Scroll the
// target into view ourselves on load and on hash changes.
export class EventLogDeeplinkController extends Controller {
  connect() {
    this.scrollToHash = this.scrollToHash.bind(this);
    window.addEventListener("hashchange", this.scrollToHash);
    // Wait a frame so the layout has settled before we measure/scroll.
    requestAnimationFrame(this.scrollToHash);
  }

  disconnect() {
    window.removeEventListener("hashchange", this.scrollToHash);
  }

  scrollToHash() {
    const hash = window.location.hash;
    if (!hash || hash === "#") return;
    const target = this.element.querySelector(hash);
    if (target) target.scrollIntoView({ block: "center" });
  }
}
